/* eslint-disable react/no-danger */
import _ from 'lodash';
import React, { useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { Link } from 'gatsby';
import { motion } from 'framer-motion';
import BoxedContainer from './layouts/BoxedContainer';
import Sprites from '../components/Sprites';

export default function FreeZoneAuthorityCoreServices({ data, id }) {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleAccordion = (index) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? -1 : index));
  };
  const {
    title,
    text,
    firstImage,
    videoUrl,
    secondVideoUrl,
    firstParagraph,
    secondParagraph,
    secondImage,
    items,
    link,
  } = data;
  return (
    <section id={id} className="bg-[#f7f7f7] md:bg-[#F2F2F2] py-[50px] md:py-[100px]">
      <div
        className="max-w-[1752px] px-4 mx-auto relative flex flex-col
      gap-y-7 md:gap-y-10 lg:gap-y-[60px]">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.4 }}
          viewport={{ once: true }}
          className="flex flex-col gap-y-7 md:gap-y-[30px]">
          <div className="flex flex-col gap-y-5">
            <div
              dangerouslySetInnerHTML={{ __html: title }}
              className="text-clamp20to40  h2-child:text-clamp20to40 text-[#231F20]
            h2-child:leading-1.2 text-center h2-child:!m-0"
            />
            <div className="h-[2px] w-[50px] md:w-[70px] bg-[#CE445B] mx-auto" />
          </div>
          <div
            dangerouslySetInnerHTML={{ __html: text }}
            className="p-child:text-[#4A4A4A] p-child:text-clamp12to18 p-child:font-normal
            p-child:leading-[1.4] p-child:mb-0 p-child:ltr:font-URWDINRegular 
            p-child:rtl:font-GESSTwoDWTCLight text-center max-w-[1170px]
            mx-auto"
          />
        </motion.div>
        <div className="flex flex-row gap-x-6 xl:gap-x-10 2xl:gap-x-[100px]">
          <div
            className="flex flex-col lg:flex-row gap-[90px] md:gap-[60px] lg:gap-[200px]
          xl:gap-[280px] 2xl:gap-[330px]">
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.5 }}
              viewport={{ once: true }}
              className="max-w-[90%] lg:max-w-[775px] relative">
              <div className="max-w-[545px] w-full relative max-h-[300px] lg:max-h-[420px]">
                {_.isEmpty(firstImage) || (
                  <LazyLoadImage
                    src={firstImage.url}
                    alt={title}
                    width="100%"
                    effect="blur"
                    className="w-full object-cover max-h-[300px] lg:max-h-[420px]"
                  />
                )}
                <div
                  className="max-w-[200px] md:max-w-[300px] xl:max-w-[400px] aspect-[400/320] 
                  absolute bottom-[-60px] xl:bottom-[-120px] ltr:right-[-30px]
                  ltr:md:right-[-125px] ltr:xl:right-[-235px] rtl:left-[-30px]
                  rtl:md:left-[-125px] rtl:xl:left-[-235px] w-full">
                  {_.isEmpty(videoUrl) ||
                    (videoUrl.includes('mp4') ? (
                      <video
                        muted
                        loop
                        autoPlay
                        playsInline
                        className="aspect-[400/320] object-cover w-full h-auto">
                        <source src={videoUrl} />
                      </video>
                    ) : (
                      <iframe
                        src={videoUrl}
                        title="freezone authority core services"
                        className="min-h-[150px] max-w-[225px] md:max-w-[400px] max-h-[150px] 
                        md:max-h-[320px]
                      w-full xl:min-h-[320px] aspect-video"
                      />
                    ))}
                </div>
              </div>
            </motion.div>
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.6 }}
              viewport={{ once: true }}
              className="lg:max-w-[300px] 2xl:max-w-[400px] flex flex-col gap-y-5
            lg:gap-y-6 md:pt-5 2xl:pt-10">
              <div
                dangerouslySetInnerHTML={{ __html: firstParagraph }}
                className="p-child:text-clamp13to18 p-child:text-[#58595B] p-child:leading-[160%]
                p-child:font-LibreBaskervilleRegular p-child:!m-0"
              />
              <div
                dangerouslySetInnerHTML={{ __html: secondParagraph }}
                className="p-child:text-clamp13to18 p-child:text-[#4A4A4A] p-child:leading-[1.55]
                p-child:font-URWDINRegular p-child:!m-0"
              />
            </motion.div>
          </div>
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.7 }}
            viewport={{ once: true }}
            className="max-w-[225px] xl:max-w-[345px] hidden lg:block">
            {_.isEmpty(secondVideoUrl) ||
              (videoUrl.includes('mp4') ? (
                <video
                  muted
                  loop
                  autoPlay
                  playsInline
                  className="w-full h-full aspect-[345/480] object-cover">
                  <source src={secondVideoUrl} />
                </video>
              ) : (
                _.isEmpty(secondImage) || (
                  <LazyLoadImage
                    src={secondImage.url}
                    alt={title}
                    width="100%"
                    effect="blur"
                    className="w-full h-full object-cover"
                  />
                )
              ))}
          </motion.div>
        </div>
      </div>
      <BoxedContainer className="pt-[70px] md:pt-[112px]">
        {_.isEmpty(items) || (
          <div className="flex flex-col md:flex-row flex-wrap gap-x-8 gap-y-[45px] md:gap-y-[90px]">
            {_.map(items, (item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.3 * (index + 1), delay: 0.7 }}
                className="bg-white border-t-[2px] border-t-[#CE445B]
                pt-[31px] md:pt-[60px] px-5 lg:px-[30px] pb-5 md:pb-10
                relative flex flex-col gap-y-[25px] md:max-w-[calc(50%-16px)]">
                <div
                  className="absolute -top-[25px] md:-top-10 left-1/2 -translate-x-1/2 w-[50px]
                  md:w-20 h-[50px] md:h-20 border-[1px] md:border-[2px] border-[#CE445B] 
                  rounded-full
                  flex justify-center items-center bg-white">
                  {_.isEmpty(item.content.serviceItemIcon) || (
                    <LazyLoadImage
                      src={item.content.serviceItemIcon.url}
                      alt={item.content.serviceItemTitle}
                      className="relative max-w-[15px] md:max-w-[30px] h-auto"
                    />
                  )}
                </div>
                <h3
                  className="ltr:text-clamp14to20 rtl:text-clamp16to24 text-[#58595B] 
                  ltr:!font-LibreBaskervilleRegular 
                  rtl:font-GESSTwoDWTCMedium 
                  leading-1.5 !m-0 md:flex hidden">
                  {item.content.serviceItemTitle}
                </h3>
                <button
                  type="button"
                  onClick={() => toggleAccordion(index)}
                  className="md:hidden flex justify-between gap-5 text-clamp14to20 text-[#58595B]
                  ltr:font-LibreBaskervilleRegular rtl:font-GESSTwoDWTCMedium leading-1.5 
                  relative
                  pt-[31px] md:pt-0 px-5 md:px-0 pb-5 md:pb-0
                  -mt-[31px] md:mt-0 -mx-5 md:mx-0 -mb-5 md:mb-0
                  ">
                  {item.content.serviceItemTitle}
                  <Sprites
                    name={openIndex === index ? 'free-zone-arrow-up' : 'free-zone-arrow-down'}
                  />
                </button>
                <div className={`md:!flex flex-col gap-y-5 ${openIndex === index ? '' : 'hidden'}`}>
                  <div
                    dangerouslySetInnerHTML={{ __html: item.content.serviceItemText }}
                    className="p-child:text-clamp12to16 p-child:text-[#4A4A4A] 
                    p-child:leading-[1.4] 
                    p-child:ltr:font-URWDINRegular 
                    p-child:rtl:font-GESSTwoDWTCLight 
                    p-child:!m-0"
                  />

                  {_.isEmpty(item.content.serviceItemList) || (
                    <div className="flex flex-col gap-y-5 pt-5 md:pt-0">
                      {_.map(item.content.serviceItemList, (serviceList, serviceListIndex) => (
                        <div
                          key={serviceListIndex}
                          className="flex flex-row gap-x-[15px] md:gap-x-5">
                          <Sprites
                            name="roundCheck"
                            className="w-[15px] md:w-[25px] min-w-[15px] md:min-w-[25px]
                              h-[15px] md:h-[25px] fill-[#CE445B] relative top-[2px] lg:top-[-4px]"
                          />
                          <span
                            className="text-clamp13to16 
                        ltr:font-URWDINRegular rtl:font-GESSTwoDWTCLight 
                        rtl:pt-[2px] rtl:md:pt-0
                        ltr:leading-[1.3] rtl:leading-[1.5]
                        text-[#4D4D4D]">
                            {serviceList}
                          </span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </motion.div>
            ))}
          </div>
        )}
        {_.isEmpty(link) || (
          <div className="flex justify-center w-full pt-10 md:pt-[50px]">
            <Link
              href={link.url}
              target={link.target}
              className=" flex justify-center text-center items-center
            rounded-[48px] bg-[#CE445B] text-white uppercase 
            ltr:font-URWDINBold rtl:font-GESSTwoDWTCMedium
            ltr:tracking-[0.96px] leading-1 h-[40px] md:h-[51px] text-[11px]
            md:text-[15px] px-8 md:px-14 md:py-5 pt-1 md:pt-6 hover:bg-[#B53B50] w-full md:w-auto">
              {link.name}
            </Link>
          </div>
        )}
      </BoxedContainer>
    </section>
  );
}
